<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path id="af3ac4aa-d61e-4d4e-a08a-a5f10d4f567d" data-name="ColorDrop"
        d="M16,0S26,15.64,26,21.46A10.28,10.28,0,0,1,16,32,10.28,10.28,0,0,1,6,21.46C6,15.64,16,0,16,0ZM13.08,10.75c-.57,3.84-1.76,9.11.75,11.38,2.12,1.91,3.06,5.39.35,5.73-3,.36-5.43-2.57-5.43-5.73S13.08,10.75,13.08,10.75Z"
        style="fill-rule:evenodd" />
</svg>